/* Northern Raised · Gift Boxes collection page
   No dependencies. Loaded with defer. Safe to include from more than one section. */
(function () {
  'use strict';
  if (window.NRGift) return;
  window.NRGift = true;

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';
    var fmt = null;
    try { fmt = new Intl.NumberFormat('en-CA', { style: 'currency', currency: currency }); } catch (err) { fmt = null; }
    var money = function (cents) {
      var n = (Number(cents) || 0) / 100;
      return fmt ? fmt.format(n) : '$' + n.toFixed(2);
    };

    /* ---------- Scroll CTAs ---------- */
    document.querySelectorAll('[data-nrg-scroll]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var target = document.querySelector(btn.getAttribute('data-nrg-scroll'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });

    /* ---------- Filters ---------- */
    var grid = document.querySelector('[data-nrg-grid]');
    if (grid) {
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-nrg-product]'));
      var chips = Array.prototype.slice.call(document.querySelectorAll('[data-nrg-chip]'));
      var clears = Array.prototype.slice.call(document.querySelectorAll('[data-nrg-clear]'));
      var empty = document.querySelector('[data-nrg-empty]');
      var live = document.querySelector('[data-nrg-results]');
      var state = { r: null, b: null };

      var hasR = function (card, v) {
        return (' ' + (card.getAttribute('data-recipients') || '') + ' ').indexOf(' ' + v + ' ') > -1;
      };
      var applyFilters = function () {
        var shown = 0;
        cards.forEach(function (c) {
          var ok = (!state.r || hasR(c, state.r)) && (!state.b || c.getAttribute('data-budget') === state.b);
          c.hidden = !ok;
          if (ok) shown++;
        });
        var filtered = !!(state.r || state.b);
        clears.forEach(function (b) { b.hidden = !filtered; });
        if (empty) empty.hidden = shown !== 0;
        if (live) live.textContent = shown + (shown === 1 ? ' box shown' : ' boxes shown');
      };

      chips.forEach(function (chip) {
        var f = chip.getAttribute('data-f');
        var v = chip.getAttribute('data-v');
        var any = cards.some(function (c) {
          return f === 'r' ? hasR(c, v) : c.getAttribute('data-budget') === v;
        });
        if (!any) { chip.hidden = true; return; } /* hide chips with no matching products */
        chip.addEventListener('click', function () {
          state[f] = state[f] === v ? null : v;
          chips.forEach(function (o) {
            if (o.getAttribute('data-f') === f) {
              o.setAttribute('aria-pressed', String(state[f] === o.getAttribute('data-v')));
            }
          });
          applyFilters();
        });
      });
      clears.forEach(function (b) {
        b.addEventListener('click', function () {
          state.r = null; state.b = null;
          chips.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          applyFilters();
        });
      });
    }

    /* ---------- What's inside (mobile toggle on cards) ---------- */
    document.querySelectorAll('[data-nrg-wi]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.nrg-wi');
        if (!wrap) return;
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
      });
    });

    /* ---------- Cart helpers ---------- */
    var toast = document.querySelector('[data-nrg-toast]');
    var toastMsg = toast ? toast.querySelector('[data-nrg-toast-msg]') : null;
    var toastTimer;
    var showToast = function (msg) {
      if (!toast || !toastMsg) return;
      toastMsg.textContent = msg;
      toast.classList.add('is-show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('is-show'); }, 4200);
    };

    var cartTarget = function () {
      var el = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (el && typeof el.getSectionsToRender === 'function' && typeof el.renderContents === 'function') return el;
      return null;
    };

    var addToCart = function (variantId, qty) {
      var target = cartTarget();
      var body = { items: [{ id: variantId, quantity: qty }] };
      if (target) {
        try {
          body.sections = target.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        } catch (err) { target = null; }
      }
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok && !data.status, data: data, target: target };
        });
      });
    };

    /* Refresh the theme's cart drawer if it speaks Dawn's API, otherwise show the toast */
    var announceAdded = function (result, btn) {
      document.dispatchEvent(new CustomEvent('nrgift:cart:added', { detail: result.data }));
      var refreshed = false;
      if (result.target) {
        try { result.target.renderContents(result.data); refreshed = true; }
        catch (err) { refreshed = false; }
      }
      if (!refreshed) {
        showToast((btn.getAttribute('data-product-title') || 'Box') + ' ' + (btn.getAttribute('data-incart-text') || 'is in your cart.'));
      }
    };

    var errorText = function (result, btn) {
      var d = (result && result.data) || {};
      return d.description || d.message || btn.getAttribute('data-error-text') || 'That box could not be added. Try the product page.';
    };

    /* ---------- Add to cart from a card ---------- */
    document.querySelectorAll('[data-nrg-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-disabled') === 'true') return;
        var variantId = Number(btn.getAttribute('data-variant-id'));
        if (!variantId) return;

        var label = btn.querySelector('[data-nrg-add-label]');
        var original = label ? label.textContent : '';
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('is-busy');
        if (label) label.textContent = btn.getAttribute('data-adding-text') || 'Adding';

        addToCart(variantId, 1)
          .then(function (result) {
            if (!result.ok) {
              showToast(errorText(result, btn));
              if (label) label.textContent = original;
              return;
            }
            announceAdded(result, btn);
            if (label) {
              label.textContent = btn.getAttribute('data-added-text') || 'Added';
              setTimeout(function () { label.textContent = original; }, 1800);
            }
          })
          .catch(function () {
            showToast(btn.getAttribute('data-error-text') || 'That box could not be added. Try the product page.');
            if (label) label.textContent = original;
          })
          .finally(function () {
            btn.removeAttribute('aria-disabled');
            btn.classList.remove('is-busy');
          });
      });
    });

    /* ---------- Quick view (See details) ---------- */
    var dialog = document.querySelector('[data-nrg-qv]');
    var qvBody = dialog ? dialog.querySelector('[data-nrg-qv-body]') : null;
    var qvReturn = null;

    var bindQuickView = function (scope) {
      /* gallery */
      var mainImg = scope.querySelector('[data-nrg-qv-main]');
      var thumbs = Array.prototype.slice.call(scope.querySelectorAll('[data-nrg-qv-thumb]'));
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (mainImg) {
            mainImg.removeAttribute('srcset');
            mainImg.src = thumb.getAttribute('data-src');
            if (thumb.getAttribute('data-srcset')) mainImg.srcset = thumb.getAttribute('data-srcset');
            mainImg.alt = thumb.getAttribute('data-alt') || '';
          }
          thumbs.forEach(function (o) { o.removeAttribute('aria-current'); });
          thumb.setAttribute('aria-current', 'true');
        });
      });

      /* price, quantity, variant, add */
      var addBtn = scope.querySelector('[data-nrg-qv-add]');
      if (!addBtn) return;
      var label = addBtn.querySelector('[data-nrg-qv-add-label]');
      var qtyInput = scope.querySelector('[data-nrg-qv-qty]');
      var select = scope.querySelector('[data-nrg-qv-variant]');
      var priceEl = scope.querySelector('[data-nrg-qv-price]');
      var compareEl = scope.querySelector('[data-nrg-qv-compare]');
      var compareVal = scope.querySelector('[data-nrg-qv-compare-val]');
      var saveEl = scope.querySelector('[data-nrg-qv-save]');
      var saveBadge = scope.querySelector('[data-nrg-qv-save-badge]');
      var msg = scope.querySelector('[data-nrg-qv-msg]');
      var busy = false;

      var current = function () {
        var src = addBtn;
        if (select) src = select.options[select.selectedIndex];
        return {
          id: Number(src.getAttribute(select ? 'value' : 'data-variant-id')),
          price: Number(src.getAttribute('data-price')) || 0,
          compare: Number(src.getAttribute('data-compare')) || 0,
          available: src.getAttribute('data-available') === 'true'
        };
      };
      var qty = function () {
        var n = parseInt(qtyInput && qtyInput.value, 10);
        if (!n || n < 1) n = 1;
        if (n > 99) n = 99;
        return n;
      };
      var render = function () {
        var v = current();
        var q = qty();
        var onSale = v.compare > v.price;
        if (priceEl) priceEl.textContent = money(v.price);
        if (compareEl) {
          compareEl.hidden = !onSale;
          if (onSale && compareVal) compareVal.textContent = money(v.compare);
        }
        if (saveEl) {
          saveEl.hidden = !onSale;
          if (onSale) saveEl.textContent = (saveEl.getAttribute('data-label') || 'You save') + ' ' + money(v.compare - v.price);
        }
        if (saveBadge) {
          saveBadge.hidden = !onSale;
          if (onSale) saveBadge.textContent = (saveBadge.getAttribute('data-label') || 'Save') + ' ' + Math.round((v.compare - v.price) * 100 / v.compare) + '%';
        }
        if (busy) return;
        addBtn.disabled = !v.available;
        if (label) {
          label.textContent = v.available
            ? (addBtn.getAttribute('data-add-text') || 'Add to cart') + ' · ' + money(v.price * q)
            : (addBtn.getAttribute('data-soldout-text') || 'Sold out');
        }
      };

      scope.querySelectorAll('[data-nrg-qv-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qtyInput) return;
          qtyInput.value = Math.min(99, Math.max(1, qty() + Number(b.getAttribute('data-nrg-qv-step'))));
          render();
        });
      });
      if (qtyInput) {
        qtyInput.addEventListener('input', render);
        qtyInput.addEventListener('change', function () { qtyInput.value = qty(); render(); });
      }
      if (select) select.addEventListener('change', render);

      addBtn.addEventListener('click', function () {
        var v = current();
        if (busy || !v.available || !v.id) return;
        busy = true;
        addBtn.classList.add('is-busy');
        addBtn.setAttribute('aria-busy', 'true');
        if (label) label.textContent = addBtn.getAttribute('data-adding-text') || 'Adding';
        if (msg) msg.textContent = '';

        addToCart(v.id, qty())
          .then(function (result) {
            if (!result.ok) {
              if (msg) msg.textContent = errorText(result, addBtn);
              return;
            }
            dialog.close();
            announceAdded(result, addBtn);
          })
          .catch(function () {
            if (msg) msg.textContent = addBtn.getAttribute('data-error-text') || 'That box could not be added. Try the product page.';
          })
          .finally(function () {
            busy = false;
            addBtn.classList.remove('is-busy');
            addBtn.removeAttribute('aria-busy');
            render();
          });
      });

      render();
    };

    var openQuickView = function (id, trigger) {
      if (!dialog || !qvBody || typeof dialog.showModal !== 'function') return false;
      var tpl = document.getElementById('nrg-qv-' + id);
      if (!tpl || !tpl.content) return false;

      qvBody.innerHTML = '';
      qvBody.appendChild(tpl.content.cloneNode(true));
      var title = qvBody.querySelector('.nrg-qv-title');
      if (title && title.id) dialog.setAttribute('aria-labelledby', title.id);

      /* return focus to the card's visible link, not the hidden image link */
      qvReturn = trigger || null;
      if (trigger && trigger.getAttribute('aria-hidden') === 'true') {
        var card = trigger.closest('[data-nrg-product]');
        qvReturn = (card && card.querySelector('.nrg-details')) || trigger;
      }

      bindQuickView(qvBody);
      document.documentElement.classList.add('nrg-qv-lock');
      dialog.showModal();
      qvBody.querySelectorAll('.nrg-qv-grid, .nrg-qv-media, .nrg-qv-info').forEach(function (el) { el.scrollTop = 0; });
      document.dispatchEvent(new CustomEvent('nrgift:qv:open', { detail: { productId: id } }));
      return true;
    };

    if (dialog) {
      var closeBtn = dialog.querySelector('[data-nrg-qv-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });
      /* a click on the dialog element itself is a click on the backdrop */
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
      dialog.addEventListener('close', function () {
        document.documentElement.classList.remove('nrg-qv-lock');
        if (qvBody) qvBody.innerHTML = '';
        if (qvReturn && document.body.contains(qvReturn)) {
          try { qvReturn.focus({ preventScroll: true }); } catch (err) { qvReturn.focus(); }
        }
        qvReturn = null;
      });
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest ? e.target.closest('[data-nrg-qv-open]') : null;
      if (!trigger) return;
      /* let new-tab and modified clicks go to the product page */
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (openQuickView(trigger.getAttribute('data-nrg-qv-open'), trigger)) e.preventDefault();
    });
  });
})();
